// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1348":"30fd5577","4745":"f176028f","5623":"f176028f","6478":"f176028f"}[chunkId] + ".chunk.css";
};